import { composeBundles, createCacheBundle } from 'redux-bundler';
import cache from '../utils/cache';

// import our application bundles
import viewportBundle from './viewport-bundle';
import uiBundle from './ui-bundle';
import basemapBundle from './basemap-bundle';
import pluginBundle from './plugin-bundle';
import configBundle from './config-bundle';
import mapProjBundle from './map-proj-bundle';
import mapViewBundle from './map-view-bundle';
import mapBasemapBundle from './map-basemap-bundle';
import mapInteractionBundle from './map-interaction-bundle';
import mapDrawingBundle from './map-drawing-bundle';
import mapLayersBundle from './map-layers-bundle';
import mapCore from './map-core-bundle';
import api from './api-bundle';
import notificationBundle from './notification-bundle';
import authBundle from './auth-bundle';
import searchBundle from './search-bundle';
import identifyBundle from './identify-bundle';
import windowLocationBundle from './window-location-bundle';

// compose the bundles into a redux store and export our new store
export default composeBundles(
  viewportBundle,
  configBundle,
  uiBundle,
  basemapBundle,
  pluginBundle,
  mapProjBundle,
  mapViewBundle,
  mapBasemapBundle,
  mapInteractionBundle,
  mapDrawingBundle,
  mapLayersBundle,
  mapCore,
  notificationBundle,
  authBundle,
  createCacheBundle(cache.set),
  api,
  searchBundle,
  identifyBundle,
  windowLocationBundle
);